module.exports = __webpack_public_path__ + "img/rc.6d622768.jpg";